import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Idea } from 'src/app/core/models/idea.models';
import { User } from 'src/app/core/models/users-models';
import { UsersBackendService } from 'src/app/core/services/backend/users-backend.service';

@Component({
  selector: 'craft-votes-counter',
  templateUrl: './craft-votes-counter.component.html',
  styleUrls: ['./craft-votes-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftVotesCounterComponent implements OnInit {
  @Input() public idea: Readonly<Idea>;
  @Input() public disabled = false;

  public users$: Observable<User[]>;

  constructor(private usersService: UsersBackendService) {}

  public ngOnInit() {
    this.users$ = this.usersService.resolveLikes(this.idea.id!, 1000);
  }

  public identify(index: number, user?: User): string | number {
    return user?.id || index;
  }
}
